
import { CurrentResponse, InvoicesResponse, PaymentAuthorizeRequest, PaymentAuthorizeResponse, PayoutCurrentResponse, PayoutStoreRequest, PayoutStoreResponse, RevolutInitRequest, RevolutInitResponse, RevolutStoreRequest, RevolutStoreResponse, StoreRequest, StoreResponse } from 'api/gen/payment';
import { adlessCommand, adlessQuery } from '.';
import { InfluencerEnrollRequest, InfluencerEnrollResponse, InfluencerProfileResponse } from 'api/gen/influencer';

export default {
 profile: () => adlessQuery<InfluencerProfileResponse>("/v1/influencer"),
 enroll: (req: InfluencerEnrollRequest) => adlessCommand<InfluencerEnrollResponse>("/v1/influencer", req),
}